import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import { Button, Col, Form, Modal as M, Row } from 'react-bootstrap';
import Dropdown from 'react-dropdown';
import {TextArea} from '@react-ui-org/react-ui';
import {ModalPerido} from '../RegistroEmpresas/ModalPerido';
import {sumarMinuto} from '../../fuctions/Sumar_Minutos_Horas';
import {sumarUnaHora} from '../../fuctions/Sumar_Minutos_Horas';
import Switch from 'react-switch';
import {Checkbox} from '@mui/material';

export const CatServAñadir = (props) => {
	const {sedes} = props;
	const [sedeSeleccionada, setsedeSeleccionada] = useState({});
	const [ServiciosPosibles, setServiciosPosibles] = useState([]);

	const [modalAnadirSede, setModalAnadirSede] = useState(false);
	/* Using the useSessionStore hook to set the state of the UsuarioContext. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
	const [ModalErrorCargarCategorias, setModalErrorCargarCategorias] = useState(false);
	const [ModalErrorCargarServicios, setModalErrorCargarServicios] = useState(false);
	const [ModalErrorConsulta, setModalErrorConsulta] = useState(false);
	const [ModalPeriodo, setModalPeriodo] = useState(false);
	const [revisarHorario, setRevisarHorario] = useState(false)
	const [ModalServicioNoCompleto, setModalServicioNoCompleto] = useState(false);
	const [ModalServicioOk, setModalServicioOk] = useState(false);
	const [ServicioPersonalizado, setServicioPersonalizado] = useState(false);

	const [ErroresFormulario, setErroresFormulario] = useState([])

	const superCat = [
		{
			id: 1,
			nombre: 'Servicio Sanitario',
		},
		{
			id: 2,
			nombre: 'Servicio Socio Sanitario',
		},
		{
			id: 3,
			nombre: 'Otro',
		},
	];
	const [ListaCategorias, setListaCategorias] = useState([]);
	const [SuperCateSeleccionada, setSuperCateSeleccionada] = useState({});
	const [ListaCategoriasFiltrada, setListaCategoriasFiltrada] = useState([]);
	const [CategoriaSelecionada, setCategoriaSelecionada] = useState({});
	const [ListaServicios, setListaServicios] = useState([]);

	const [ServicioSeleccionado, setServicioSeleccionado] = useState({
		categoria_id: 0,
		nombre: '',
		nombrePersonalizado: '',
		estado: true,
		horasMin: 0,
		shareCare: false,
		domicilio: false,
		precioMin: 0,
		sedes: [],
		horario: [
			{
				nombre: 'lunes',
				estado: true,
				periodos: [
					{
						id: 1,
						hora_inicio: '08:00',
						hora_fin: '16:00',
						solapamiento: false,
					},
				],
			},
			{
				nombre: 'martes',
				estado: true,
				periodos: [
					{
						id: 1,
						hora_inicio: '08:00',
						hora_fin: '16:00',
						solapamiento: false,
					},
				],
			},
			{
				nombre: 'miercoles',
				estado: true,
				periodos: [
					{
						id: 1,
						hora_inicio: '08:00',
						hora_fin: '16:00',
						solapamiento: false,
					},
				],
			},
			{
				nombre: 'jueves',
				estado: true,
				periodos: [
					{
						id: 1,
						hora_inicio: '08:00',
						hora_fin: '16:00',
						solapamiento: false,
					},
				],
			},
			{
				nombre: 'viernes',
				estado: true,
				periodos: [
					{
						id: 1,
						hora_inicio: '08:00',
						hora_fin: '16:00',
						solapamiento: false,
					},
				],
			},
			{
				nombre: 'sabado',
				estado: false,
				periodos: [
					{
						id: 1,
						hora_inicio: '08:00',
						hora_fin: '16:00',
						solapamiento: false,
					},
				],
			},
			{
				nombre: 'domingo',
				estado: false,
				periodos: [
					{
						id: 1,
						hora_inicio: '08:00',
						hora_fin: '20:00',
						solapamiento: false,
					},
				],
			},
		],
	});
	useEffect(() => {
		// Verifica si el precio mínimo de ServicioSeleccionado es menor que 0.
		if (ServicioSeleccionado.precioMin < 0) {
			// Actualiza el estado de ServicioSeleccionado estableciendo el precio mínimo como 0.0 (convertido a tipo float).
			setServicioSeleccionado({...ServicioSeleccionado, precioMin: parseFloat(0.0)});
		}

		// Verifica si el precio mínimo de ServicioSeleccionado es mayor que 999.
		if (ServicioSeleccionado.precioMin > 999) {
			// Actualiza el estado de ServicioSeleccionado estableciendo el precio mínimo como 999.0 (convertido a tipo float).
			setServicioSeleccionado({...ServicioSeleccionado, precioMin: parseFloat(999.0)});
		}
	}, [ServicioSeleccionado]);

	/**
	 * Obtiene las categorías y actualiza el estado de ListaCategorias.
	 */
	const getCategorias = () => {
		// Realiza una solicitud HTTP GET utilizando Axios.
		axios({
			method: 'get',
			url: window.ipdirection + 'categoria/',
		})
			.then((response) => {
				// Actualiza el estado de ListaCategorias con los datos de las categorías obtenidas.
				setListaCategorias([...response.data]);
			})
			.catch((error) => {
				console.error(error);
				setModalErrorCargarCategorias(true);
			});
	};

	/**
	 * Obtiene los servicios asociados a una categoría y actualiza el estado de ServicioSeleccionado y ListaServicios.
	 * @param {string} id - ID de la categoría para filtrar los servicios.
	 */
	const getServicios = (id) => {
		// Realiza una solicitud HTTP GET utilizando Axios.
		axios({
			method: 'get',
			url: window.ipdirection + 'servicio/',
		})
			.then((response) => {
				// Inicializa una lista vacía para almacenar los servicios filtrados.
				let lista = [];

				// Filtra la respuesta de la solicitud según el ID de la categoría.
				response.data.filter((servicio) => {
					// Verifica si el ID de la categoría del servicio coincide con el ID proporcionado.
					if (servicio.categoria_id.id === id) {
						// Actualiza el estado de ServicioSeleccionado copiando los atributos del servicio seleccionado.
						setServicioSeleccionado({...ServicioSeleccionado, ...servicio});
						// Agrega el servicio a la lista de servicios filtrados.
						lista.push(servicio);
					}
				});
				// Actualiza el estado de ListaServicios con la lista de servicios filtrados.
				setListaServicios([...lista]);
			})
			.catch((error) => {
				console.error(error);
				setModalErrorCargarServicios(true);
			});
	};

	/**
	 * Selecciona una sede y actualiza el estado de sedeSeleccionada.
	 * @param {string} id - Id de la sede a seleccionar.
	 */
	const seleccionarSede = (id, indice) => {
		const listAux = [...ServiciosPosibles];
		setServiciosPosibles(listAux);
		// Iteramos sobre cada sede en sedes.
		sedes.map((sede, index) => {
			// Verificamos si el id de la sede coincide.
			if (sede.id === id) {
				if (!ServicioSeleccionado.sedes.includes(id)) {
					// Actualizamos el estado de sedeSeleccionada con los atributos de la sede seleccionada.
					ServicioSeleccionado.sedes.push(id);
					setsedeSeleccionada({...sedeSeleccionada, [id]: id});
				} else {
					// Actualizamos el estado de sedeSeleccionada con los atributos de la sede seleccionada.
					ServicioSeleccionado.sedes.splice(ServicioSeleccionado.sedes.indexOf(id), 1);
					delete sedeSeleccionada[id];
				}
			}
		});
	};

	/**
	 * Selecciona una supercategoría y actualiza el estado de SuperCateSeleccionada, así como la lista de categorías filtrada.
	 * @param {string} nombre - Nombre de la supercategoría a seleccionar.
	 */
	const seleccionarSuperCat = (nombre) => {
		// Iteramos sobre cada supercategoría en superCat.
		superCat.map((supercat) => {
			// Verificamos si el nombre de la supercategoría coincide.
			if (supercat.nombre === nombre) {
				// Actualizamos el estado de SuperCateSeleccionada con los atributos de la supercategoría seleccionada.
				setSuperCateSeleccionada({...supercat});

				// Filtramos la lista de categorías para obtener las categorías asociadas a la supercategoría seleccionada.
				const categoriasFiltradas = ListaCategorias.filter((categoria) => {
					// Verificamos si la supercategoría de la categoría coincide con el ID de la supercategoría seleccionada.
					if (categoria.superCategoria === supercat.id) {
						// Actualizamos el estado de CategoriaSeleccionada para borrar cualquier selección previa.
						setCategoriaSelecionada({});
						return categoria;
					}
				});

				// Actualizamos el estado de ListaCategoriasFiltrada con las categorías filtradas.
				setListaCategoriasFiltrada(categoriasFiltradas);
			}
		});
	};

	/**
	 * Selecciona una categoría y actualiza el estado de CategoriaSeleccionada.
	 * @param {string} nombre - Nombre de la categoría a seleccionar.
	 */
	const seleccionarCategoria = (nombre) => {
		// Iteramos sobre cada categoría en la lista de categorías filtrada.
		ListaCategoriasFiltrada.map((categoria) => {
			// Verificamos si el nombre de la categoría coincide.
			if (categoria.nombre === nombre) {
				// Actualizamos el estado de CategoriaSeleccionada con los atributos de la categoría seleccionada.
				setCategoriaSelecionada({...categoria});

				// Obtenemos los servicios asociados a la categoría seleccionada.
				// getServicios(categoria.id);
			}
		});
	};

	useEffect(()=>{
		if(CategoriaSelecionada.id){
			getServicios(CategoriaSelecionada.id)
			setServicioSeleccionado({...ServicioSeleccionado, categoria_id: CategoriaSelecionada.id})
		}
	},[CategoriaSelecionada])

	/**
	 * Selecciona un servicio y actualiza el estado de ServicioSeleccionado.
	 * @param {string} nombre - Nombre del servicio a seleccionar.
	 */
	const seleccionarServicio = (nombre) => {
		// Iteramos sobre cada servicio en la lista de servicios.
		ListaServicios.map((servicio) => {
			// Verificamos si el nombre del servicio coincide.
			if (servicio.nombre === nombre) {
				// Actualizamos el estado de ServicioSeleccionado copiando los atributos del servicio seleccionado.
				setServicioSeleccionado({...ServicioSeleccionado, ...servicio});
			}
		});
	};

	useEffect(() => {
		getCategorias();
	}, []);

	/**
	 * Cambia el estado de un día en el horario de un servicio seleccionado.
	 * @param {string} id - ID del servicio seleccionado.
	 * @param {string} nombre - Nombre del día en el horario.
	 */
	const changeServicioHorarioDiaEstado = (id, nombre) => {
		// Copiamos el objeto ServicioSeleccionado usando el operador de propagación (spread operator).
		let serv = {...ServicioSeleccionado};

		// Recorremos cada día en el horario del servicio.
		serv.horario.map((dia) => {
			// Verificamos si el nombre del día coincide.
			if (nombre === dia.nombre) {
				// Cambiamos el estado del día invirtiendo su valor actual.
				dia.estado = !dia.estado;
			}
		});

		// Actualizamos el servicio seleccionado con los cambios realizados.
		setServicioSeleccionado({...serv});
	};

	/**
	 * Cambia la hora de inicio o fin de un periodo en el horario de un servicio seleccionado.
	 * @param {string} id - ID del servicio seleccionado.
	 * @param {string} nombre - Nombre del día en el horario.
	 * @param {string} per_id - ID del periodo.
	 * @param {boolean} init_fin - Indica si se va a cambiar la hora de inicio (true) o la hora de fin (false).
	 * @param {Event} event - Evento que contiene el valor de la nueva hora.
	 */
	const cambiarHora = (id, nombre, per_id, init_fin, event) => {
		// Copiamos el objeto ServicioSeleccionado usando el operador de propagación (spread operator).
		let serv = {...ServicioSeleccionado};

		// Recorremos cada día en el horario del servicio.
		serv.horario.map((dia) => {
			// Verificamos si el nombre del día coincide.
			if (nombre === dia.nombre) {
				// Recorremos cada periodo en el día.
				dia.periodos.map((periodo) => {
					// Verificamos si el ID del periodo coincide.
					if (per_id === periodo.id) {
						// Actualizamos la hora de inicio o fin del periodo según el valor de init_fin.
						if (init_fin) {
							periodo.hora_inicio = event.target.value;
						} else {
							periodo.hora_fin = event.target.value;
						}
					}
				});
			}
		});

		// Actualizamos el servicio seleccionado con los cambios realizados.
		setServicioSeleccionado({...serv});
	};

	/**
	 * Añade un nuevo periodo al horario de un servicio seleccionado.
	 * @param {string} id - ID del servicio seleccionado.
	 * @param {string} nombre - Nombre del día en el horario.
	 */
	const anadirPeriodo = (id, nombre) => {
		// Copiamos el objeto ServicioSeleccionado usando el operador de propagación (spread operator).
		let serv = {...ServicioSeleccionado};

		// Recorremos cada día en el horario del servicio.
		serv.horario.map((dia) => {
			// Verificamos si el nombre del día coincide.
			if (nombre === dia.nombre) {
				// Generamos un nuevo periodo y lo añadimos al final de los periodos existentes.
				dia.periodos.push({
					id: dia.periodos[dia.periodos.length - 1].id + 1,
					hora_inicio: sumarMinuto(dia.periodos[dia.periodos.length - 1].hora_fin),
					hora_fin: sumarMinuto(
						sumarUnaHora(dia.periodos[dia.periodos.length - 1].hora_fin)
					),
					solapamiento: false,
				});
			}
		});

		// Actualizamos el servicio seleccionado con los cambios realizados.
		setServicioSeleccionado({...serv});
	};

	/**
	 * Borra un periodo del horario de un servicio seleccionado.
	 * @param {string} id - ID del servicio seleccionado.
	 * @param {string} nombre - Nombre del día en el horario.
	 * @param {string} per_id - ID del periodo a borrar.
	 */
	const borrarPeriodo = (id, nombre, per_id) => {
		// Copiamos el objeto ServicioSeleccionado usando el operador de propagación (spread operator).
		let serv = {...ServicioSeleccionado};

		// Recorremos cada día en el horario del servicio.
		serv.horario.map((dia) => {
			// Verificamos si el nombre del día coincide y si tiene más de un periodo.
			if (nombre === dia.nombre && dia.periodos.length > 1) {
				// Eliminamos el último periodo del día usando el método pop().
				dia.periodos.pop();
			}
		});

		// Actualizamos el servicio seleccionado con los cambios realizados.
		setServicioSeleccionado({...serv});
	};

	/**
	 * Verifica si el servicio seleccionado está completo.
	 * @returns {boolean} true si el servicio está completo, de lo contrario false.
	 */
	const servicioCompleto = () => {
		let listadoErrores = [];
		// Copiamos el objeto ServicioSeleccionado usando el operador de propagación (spread operator).
		let objeto = {...ServicioSeleccionado};

		// Verificamos si el objeto es nulo o indefinido.
		if (objeto === null || objeto === undefined) {
			listadoErrores.push('No se ha definido ningún servicio.');
		}

		// Recorremos cada atributo en el objeto.
		for (let atributo in objeto) {
			// Verificamos si el atributo es nulo, indefinido o si su precio mínimo es 0.
			if (
				objeto[atributo] === null ||
				objeto[atributo] === undefined ||
				objeto[atributo].precioMin === 0
			) {
				return false;
			}
		}

		// Verificamos si el precio mínimo es nulo, indefinido o 0.
		if (objeto.precioMin === null || objeto.precioMin === undefined || isNaN(objeto.precioMin)) {
			listadoErrores.push('El precio mínimo no puede estar vacío.');
		}

		// Verificamos si las horas mínimas son 0.
		if (objeto.horasMin === 0 || objeto.horasMin === null || objeto.horasMin === undefined || isNaN(objeto.horasMin)) {
			listadoErrores.push('Debe asignar un rango de tiempo.');
		}

		// Verificamos si la descripción está vacía.
		if (objeto.descripcion === '' || objeto.descripcion === null || objeto.descripcion === undefined) {
			listadoErrores.push('La descripción no puede estar vacía.');
		}

		if (Object.keys(sedeSeleccionada).length === 0) {
			listadoErrores.push('Debe seleccionar al menos una sede');
		}

		if(!revisarHorario) {
			listadoErrores.push('No ha seleccionado ningún horario')
		}

		if (listadoErrores.length > 0) {
			setErroresFormulario(listadoErrores);
			return false;
		}

		// Si todas las verificaciones pasan, el servicio se considera completo.
		return true;
	};
	const enviarCategoriaNueva = () => {
		axios({
			method: 'post',
			url: window.ipdirection + 'categoriaEmpresa/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: {
				empresa_id: Usuario.prestadorServicios.id,
				categoria_id: ServicioSeleccionado.categoria_id.id,
			},
		})
			.then((response) => {
				if (ServicioPersonalizado) {
					// Verifica si el nombre personalizado del servicio no está vacío.
					if (ServicioSeleccionado.nombrePersonalizado !== '') {
						// Envia el servicio personalizado utilizando la función enviarServicioPersonalizado().
						enviarServicioPersonalizado();
					} else {
						// Muestra el modal de servicio no completo.
						setModalServicioNoCompleto(true);
					}
				} else {
					// Se comprueba si la categoria ya esta registrada
					enviarServicioNormal();
				}
			})
			.catch((error) => {
				setModalErrorConsulta(true);
				console.log(error.error);
			});
	};
	/**
	 * Comprueba las categorías de la empresa y realiza las acciones correspondientes.
	 */
	const comprobarCategorias = () => {
		// Realiza una solicitud HTTP GET utilizando Axios.
		axios({
			method: 'get',
			url: window.ipdirection + 'categoriaEmpresa/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				let esta = false;

				// Verifica si la categoría del ServicioSeleccionado está presente en los datos de categorías de la empresa.
				response.data.map((categoria) => {
					if (categoria.categoria_id.id === ServicioSeleccionado.categoria_id) {
						esta = true;
						// Envía el servicio normal si la categoría está presente.
						// Verifica si el servicio es personalizado.
						if (ServicioPersonalizado) {
							// Verifica si el nombre personalizado del servicio no está vacío.
							if (ServicioSeleccionado.nombrePersonalizado !== '') {
								// Envia el servicio personalizado utilizando la función enviarServicioPersonalizado().
								enviarServicioPersonalizado();
							} else {
								// Muestra el modal de servicio no completo.
								setModalServicioNoCompleto(true);
							}
						} else {
							// Se comprueba si la categoria ya esta registrada
							enviarServicioNormal();
						}
					}
				});
				// Si la categoría no está presente, se envía una categoría nueva.
				if (!esta) {
					enviarCategoriaNueva();
				}
			})
			.catch((error) => {
				setModalErrorConsulta(true);
				console.log(error);
			});
	};

	const enviarPeriodos = (servicio_id_id) => {
		ServicioSeleccionado.horario.forEach((dia) => {
			let nombre = '';
			if (dia.estado) {
				nombre = dia.nombre;
				// Loop through each period in the day
				dia.periodos.forEach((per) => {
					// Create the data object with the period information
					let data = {
						hora_inicio: per.hora_inicio,
						hora_fin: per.hora_fin,
						servicio_empresa: servicio_id_id,
						nombre: nombre,
					};
					// Send a POST request to the server to create the period
					axios({
						method: 'post',
						url: window.ipdirection + 'periodoServicioEmpresa/',
						headers: {
							Authorization: 'Bearer ' + Usuario.access,
						},
						data: data,
					})
						.then((response) => {})
						.catch((error) => {
							console.log(error);
						});
				});
			}
		});
		setModalServicioOk(true);
	};
	const enviarServicioNormal = (servicio_id) => {
		let idServ;

		if (servicio_id === null || servicio_id === undefined) {
			idServ = ServicioSeleccionado.id;
		} else {
			idServ = servicio_id;
		}

		let data = {
			prestadorServicios_id: Usuario.prestadorServicios.id,
			servicio_id: idServ,
			precioMin: ServicioSeleccionado.precioMin,
			horasMin: ServicioSeleccionado.horasMin,
			descripcion: ServicioSeleccionado.descripcion,
			shareCare: ServicioSeleccionado.shareCare,
			domicilio: ServicioSeleccionado.domicilio,
			sedes: ServicioSeleccionado.sedes,
			estado: ServicioSeleccionado.estado,
			idsSedes: sedeSeleccionada,
		};

		axios({
			method: 'post',
			url: window.ipdirection + 'servicioEmpresa/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: data,
		})
			.then((response) => {
				let servicio_id_id = response.data.servicio_Empresa.id;
				enviarPeriodos(servicio_id_id);
			})
			.catch((error) => {
				setModalErrorConsulta(true);
				console.log(error);
			});
	};

	const enviarServicioPersonalizado = () => {
		const data = {
			nombre: ServicioSeleccionado.nombrePersonalizado,
			categoria_id: ServicioSeleccionado.categoria_id,
		};
		axios({
			method: 'post',
			url: window.ipdirection + 'servicio/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: data,
		})
			.then((response) => {
				const servicio_id = response.data.id;
				enviarServicioNormal(servicio_id);
			})
			.catch((error) => {
				setModalErrorConsulta(true);
				console.log(error);
			});
	};

	/**
	 * Envia el servicio si está completo y cumple con todas las condiciones.
	 */
	const enviarServicio = () => {
		// Verifica si el servicio está completo utilizando la función servicioCompleto().
		if (servicioCompleto()) {
			comprobarCategorias();
		} else {
			// Muestra el modal de servicio no completo.
			setModalServicioNoCompleto(true);
		}
	};

	return (
		<>
			<div className='Body-CatServañadir'>
				<div className='content-Body-CatServañadir'>
					<div className='title-CatServActivos title-1'>
						<h2>Añadir servicio</h2>
					</div>
					<div className='separador' />
					<div className='lista-inputs-añadir-servicio'>
						<div className='input-añadir-servicio'>
							<div className='fw-bold d-flex align-items-top gap-1'>
								<div>
									Super-Categoria:
								</div>
								<div>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='10'
										height='10'
										fill='currentColor'
										class='bi bi-asterisk'
										viewBox='0 0 16 16'
										color='red'
									>
										<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
									</svg>
								</div>
							</div>
							<Dropdown
								options={superCat.map((supercat) => {
									return supercat.nombre;
								})}
								onChange={(e) => seleccionarSuperCat(e.value)}
								value={SuperCateSeleccionada.nombre}
								placeholder={'-- Selecionar --'}
							/>
						</div>

						{SuperCateSeleccionada.id !== undefined && (
							<div className='input-añadir-servicio'>
								<div className='fw-bold d-flex align-items-top gap-1'>
									<div>
										Categoria:
									</div>
									<div>
										<svg
											xmlns='http://www.w3.org/2000/svg'
											width='10'
											height='10'
											fill='currentColor'
											class='bi bi-asterisk'
											viewBox='0 0 16 16'
											color='red'
										>
											<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
										</svg>
									</div>
								</div>
								<Dropdown
									options={ListaCategoriasFiltrada.map((categoria) => {
										return categoria.nombre;
									})}
									onChange={(e) => seleccionarCategoria(e.value)}
									value={CategoriaSelecionada.nombre}
									placeholder={'-- Selecionar --'}
								/>
							</div>
						)}

						{CategoriaSelecionada.id !== undefined && (
							<>
								<div className='input-añadir-servicio_switch'>
									<div className='fw-bold d-flex align-items-top gap-1'>
									<div>
										Servicio Personalizado:
									</div>
										<div>
											<svg
												xmlns='http://www.w3.org/2000/svg'
												width='10'
												height='10'
												fill='currentColor'
												class='bi bi-asterisk'
												viewBox='0 0 16 16'
												color='red'
											>
												<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
											</svg>
										</div>
									</div>
									<Switch
										onChange={() =>
											setServicioPersonalizado(!ServicioPersonalizado)
										}
										checked={ServicioPersonalizado}
										onColor='#23C290'
										uncheckedIcon={false}
									/>
								</div>
								{!ServicioPersonalizado ? (
									<div className='input-añadir-servicio'>
										<div className='fw-bold d-flex align-items-top gap-1'>
											<div>
												Servicio:
											</div>
											<div>
												<svg
													xmlns='http://www.w3.org/2000/svg'
													width='10'
													height='10'
													fill='currentColor'
													class='bi bi-asterisk'
													viewBox='0 0 16 16'
													color='red'
												>
													<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
												</svg>
											</div>
										</div>
										<Dropdown
											options={ListaServicios.map((servicio) => {
												return servicio.nombre;
											})}
											onChange={(e) => seleccionarServicio(e.value)}
											value={ServicioSeleccionado.nombre}
											placeholder={'-- Selecionar --'}
										/>
									</div>
								) : (
									<div className='input-añadir-servicio'>
										<div className='fw-bold d-flex align-items-top gap-1'>
											<div>
												Nombre del servicio:
											</div>
											<div>
												<svg
													xmlns='http://www.w3.org/2000/svg'
													width='10'
													height='10'
													fill='currentColor'
													class='bi bi-asterisk'
													viewBox='0 0 16 16'
													color='red'
												>
													<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
												</svg>
											</div>
										</div>
										<input
											className='text'
											class='form-control'
											value={ServicioSeleccionado.nombrePersonalizado}
											onChange={(e) =>
												setServicioSeleccionado({
													...ServicioSeleccionado,
													nombrePersonalizado: e.target.value,
												})
											}
										/>
									</div>
								)}
								<div className='input-añadir-servicio_switch'>
									<div className='fw-bold d-flex align-items-center gap-1'>
										<div>
											¿Ofrece este servicio a domicilio?:
										</div>
									</div>
									<Switch
										onChange={() =>
											setServicioSeleccionado({
												...ServicioSeleccionado,
												domicilio: !ServicioSeleccionado.domicilio,
											})
										}
										checked={ServicioSeleccionado.domicilio}
										onColor='#23C290'
										uncheckedIcon={false}
									/>

									{/* <div className='dato-servicio-nuevo'>
										{ServicioSeleccionado.domicilio ? (
											<>
												<div className='label-formulario-registro'>
													<div>
														<b>ShareCare :</b>
													</div>
												</div>
												<Switch
													onChange={() =>
														setServicioSeleccionado({
															...ServicioSeleccionado,
															shareCare:
																!ServicioSeleccionado.shareCare,
														})
													}
													checked={ServicioSeleccionado.shareCare}
													onColor='#23C290'
													uncheckedIcon={false}
												/>
											</>
										) : (
											<>
												<div />
												<div />
											</>
										)}
									</div> */}

								</div>
								<div className='datos-servicio-nuevo'>
									<div className='dato-servicio-nuevo'>
										<div className='fw-bold d-flex align-items-top gap-1'>
											<div>
												Duración (min):
											</div>
											<div>
												<svg
													xmlns='http://www.w3.org/2000/svg'
													width='10'
													height='10'
													fill='currentColor'
													class='bi bi-asterisk'
													viewBox='0 0 16 16'
													color='red'
												>
													<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
												</svg>
											</div>
										</div>
										<Dropdown
											options={['10', '20', '30', '45', '60', '90', '120']}
											onChange={(e) =>
												setServicioSeleccionado({
													...ServicioSeleccionado,
													horasMin: parseInt(e.value),
												})
											}
											value={ServicioSeleccionado.horasMin.toString()}
										/>
									</div>
									<div className='dato-servicio-nuevo'>
										<div className='fw-bold d-flex align-items-top gap-1'>
											<div>
												Precio (€):
											</div>
											<div>
												<svg
													xmlns='http://www.w3.org/2000/svg'
													width='10'
													height='10'
													fill='currentColor'
													class='bi bi-asterisk'
													viewBox='0 0 16 16'
													color='red'
												>
													<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
												</svg>
											</div>
										</div>
										<input
											type='number'
											className='form-control text-dark'
											value={ServicioSeleccionado.precioMin}
											step='0.05'
											onChange={(e) => {
												setServicioSeleccionado({
													...ServicioSeleccionado,
													precioMin: parseFloat(e.target.value),
												});
											}}
										/>
									</div>
								</div>

								<div className='input-añadir-servicio'>
									<div className='fw-bold d-flex align-items-top gap-1'>
										<div>
											Sedes en las que está disponible este servicio:
										</div>
										<div>
											<svg
												xmlns='http://www.w3.org/2000/svg'
												width='10'
												height='10'
												fill='currentColor'
												class='bi bi-asterisk'
												viewBox='0 0 16 16'
												color='red'
											>
												<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
											</svg>
										</div>
									</div>
									{sedes.map((sede, index) => (
										<div className='d-flex align-items-center'>
											<Checkbox
												className='form-check-input me-2'
												id={sede.id}
												sx={{
													color: '23C290',
													'&.Mui-checked': {color: '#23C290'},
												}}
												checked={ServicioSeleccionado.sedes.includes(
													sede.id
												)}
												onChange={(e) => seleccionarSede(sede.id, index)}
											/>
											<label htmlFor={sede.id} className='cursor-pointer m-0'>
												{sede.nombreSede}
											</label>
										</div>
									))}
								</div>

								<div className='input-añadir-servicio'>
									<div className='fw-bold d-flex align-items-top gap-1'>
										<div>
											Descripción del servicio:
										</div>
										<div>
											<svg
												xmlns='http://www.w3.org/2000/svg'
												width='10'
												height='10'
												fill='currentColor'
												class='bi bi-asterisk'
												viewBox='0 0 16 16'
												color='red'
											>
												<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
											</svg>
										</div>
									</div>
									<div>
										<textarea
											Id='textArea'
											className='form-control text-dark'
											placeholder={'Descripción del servicio'}
											name={'descripcionEmpresa'}
											value={ServicioSeleccionado.descripcion}
											onChange={(e) =>
												setServicioSeleccionado({
													...ServicioSeleccionado,
													descripcion: e.target.value,
												})
											}
											fullWidth={true}
										/>
									</div>
								</div>
								<div className='centrador'>
									<button
										type="button"
										className="d-flex align-items-center gap-2 btn login-boton px-3 py-2 shadow-sm"
										onClick={() => {setModalPeriodo(true);setRevisarHorario(true)}}
									>
										<i className="bi bi-calendar2-week-fill fs-5"></i>
										<span className="fw-medium">Seleccionar Horario</span>
									</button>
								</div>
								<div className='input-añadir-servicio_switch my-2'>
									<div className='fw-bold d-flex align-items-center gap-1'>
										<div>
											¿Quiere que este servicio aparezca como activo?:
										</div>
									</div>
									<Switch
										onChange={() =>
											setServicioSeleccionado({
												...ServicioSeleccionado,
												estado: !ServicioSeleccionado.estado,
											})
										}
										checked={ServicioSeleccionado.estado}
										onColor='#23C290'
										uncheckedIcon={false}
									/>
								</div>
							</>
						)}
					</div>
				</div>
				<div
					className='centradorRight'
					onClick={enviarServicio}
				>
					<button className='btn login-boton'>
						<b>Enviar</b>
					</button>
				</div>
			</div>
		{/* <div className=' w-75 mt-3 mx-auto'>
			<div className="bg-white py-4 px-3 shadow-sm rounded">
				<h2 className="mb-4 fw-semibold text-center">Añadir servicio</h2>
				<hr />

				<Form className='d-flex flex-column gap-1'>
					<Form.Group className="mb-3" controlId="superCategoria">
					<Form.Label className="fw-bold d-flex align-items-center gap-1">
						Super-Categoria
						<small className="text-danger">*</small>
					</Form.Label>
					<Dropdown
						className="w-100"
						options={superCat.map((sc) => sc.nombre)}
						onChange={(e) => seleccionarSuperCat(e.value)}
						value={SuperCateSeleccionada.nombre}
						placeholder="-- Seleccionar --"
					/>
					</Form.Group>

					{SuperCateSeleccionada.id !== undefined && (
					<Form.Group className="mb-3" controlId="categoria">
						<Form.Label className="fw-bold d-flex align-items-center gap-1">
						Categoria
						<small className="text-danger">*</small>
						</Form.Label>
						<Dropdown
							className="w-100"
							options={ListaCategoriasFiltrada.map((cat) => cat.nombre)}
							onChange={(e) => seleccionarCategoria(e.value)}
							value={CategoriaSelecionada.nombre}
							placeholder="-- Seleccionar --"
							/>
					</Form.Group>
					)}

					{CategoriaSelecionada.id !== undefined && (
					<>
						<Form.Group className="d-flex align-items-center justify-content-between mb-3" controlId="servicioPersonalizadoSwitch">
							<Form.Label className="fw-bold mb-0 d-flex align-items-center gap-1">
								Servicio Personalizado
								<small className="text-danger">*</small>
							</Form.Label>
							<Switch
								onChange={() =>
									setServicioPersonalizado(!ServicioPersonalizado)
								}
								checked={ServicioPersonalizado}
								onColor='#23C290'
								uncheckedIcon={false}
							/>
						</Form.Group>

						{!ServicioPersonalizado ? (
						<Form.Group className="mb-3" controlId="servicio">
							<Form.Label className="fw-bold d-flex align-items-center gap-1">
							Servicio
							<small className="text-danger">*</small>
							</Form.Label>
							<Dropdown
								className="w-100"
								options={ListaServicios.map((serv) => serv.nombre)}
								onChange={(e) => seleccionarServicio(e.value)}
								value={ServicioSeleccionado.nombre}
								placeholder="-- Seleccionar --"
							/>
						</Form.Group>
						) : (
						<Form.Group className="mb-3" controlId="nombreServicioPersonalizado">
							<Form.Label className="fw-bold d-flex align-items-center gap-1">
								Nombre del servicio
								<small className="text-danger">*</small>
							</Form.Label>
							<Form.Control
								type="text"
								value={ServicioSeleccionado.nombrePersonalizado}
								onChange={(e) =>
									setServicioSeleccionado({ ...ServicioSeleccionado, nombrePersonalizado: e.target.value })
								}
								placeholder="Nombre del servicio personalizado"
								/>
						</Form.Group>
						)}
						
						<Form.Group controlId="domicilioSwitch" className="d-flex align-items-center justify-content-between">
							<Form.Label className="fw-bold mb-0">Domicilio</Form.Label>
							<Switch
								onChange={() =>
								setServicioSeleccionado({ ...ServicioSeleccionado, domicilio: !ServicioSeleccionado.domicilio })
								}
								checked={ServicioSeleccionado.domicilio}
								onColor="#23C290"
								uncheckedIcon={false}
							/>
						</Form.Group>

						<Row className="mb-3">
							<Col xs={6}>
								<Form.Group controlId="duracion" className="mb-0">
								<Form.Label className="fw-bold d-flex align-items-center gap-1">
									Duración (min)
									<small className="text-danger">*</small>
								</Form.Label>
								<Dropdown
									className="w-100"
									options={['10', '20', '30', '45', '60', '90', '120']}
									onChange={(e) =>
									setServicioSeleccionado({ ...ServicioSeleccionado, horasMin: parseInt(e.value) })
									}
									value={ServicioSeleccionado.horasMin.toString()}
								/>
								</Form.Group>
							</Col>
							<Col xs={6}>
								<Form.Group className="mb-3" controlId="precio">
									<Form.Label className="fw-bold d-flex align-items-center gap-1">
										Precio (€)
										<small className="text-danger">*</small>
									</Form.Label>
									<Form.Control
										type="number"
										className='text-dark'
										step="0.05"
										value={ServicioSeleccionado.precioMin}
										onChange={(e) =>
											setServicioSeleccionado({ ...ServicioSeleccionado, precioMin: parseFloat(e.target.value) })
											}
										placeholder="Precio en euros"
									/>
								</Form.Group>
							</Col>
						</Row>

						<Form.Group className="mb-3" controlId="sedesDisponibles">
						<Form.Label className="fw-bold">
							Sedes en las que está disponible el servicio
							<small className="text-danger">*</small>
						</Form.Label>
						{sedes.map((sede, idx) => (
							<Form.Check
								key={sede.id}
								type="checkbox"
								label={sede.nombreSede}
								checked={ServicioSeleccionado.sedes.includes(sede.id)}
								onChange={() => seleccionarSede(sede.id, idx)}
								className="mb-1"
								/>
						))}
						</Form.Group>

						<Form.Group className="mb-4" controlId="descripcionServicio">
							<Form.Label className="fw-bold d-flex align-items-center gap-1">
								Descripción del servicio
								<small className="text-danger">*</small>
							</Form.Label>
							<Form.Control
								as="textarea"
								className='text-dark'
								rows={3}
								value={ServicioSeleccionado.descripcion}
								onChange={(e) =>
								setServicioSeleccionado({ ...ServicioSeleccionado, descripcion: e.target.value })
								}
								placeholder="Descripción del servicio"
							/>
						</Form.Group>

						<div className="d-flex justify-content-center mb-3">
							<Button
								variant="outline-primary"
								className="d-flex align-items-center gap-2 px-3 login-boton"
								onClick={() => {
								setModalPeriodo(true);
								setRevisarHorario(true);
								}}
							>
								<i className="bi bi-calendar2-week-fill fs-5"></i>
								Seleccionar Horario
							</Button>
						</div>

						<Form.Group controlId="activarServicio" className="d-flex align-items-center justify-content-between my-4">
							<Form.Label className="fw-bold mb-0">¿Desea que el servicio aparezca como activo?</Form.Label>
							<Switch
								onChange={() =>
								setServicioSeleccionado({ ...ServicioSeleccionado, estado: !ServicioSeleccionado.estado })
								}
								checked={ServicioSeleccionado.estado}
								onColor="#23C290"
								uncheckedIcon={false}
								size={'xs'}
							/>
						</Form.Group>
					</>
					)}
				</Form>
			</div>
			<div className="d-flex justify-content-end my-2">
				<Button type="button" variant="success" className='login-boton' onClick={enviarServicio}>
					Enviar
				</Button>
			</div>
		</div> */}

			<ModalPerido
				ModalPer={ModalPeriodo}
				setModalPer={setModalPeriodo}
				servicio={ServicioSeleccionado}
				changeServicioHorarioDiaEstado={changeServicioHorarioDiaEstado}
				cambiarHora={cambiarHora}
				anadirPeriodo={anadirPeriodo}
				borrarPeriodo={borrarPeriodo}
			/>

			<M
				centered={true}
				show={ModalServicioNoCompleto}
			>
				<M.Header>
					<div className='titulo-modal'>Ups... !</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-servicio descripcion-modal'>
						{
							ErroresFormulario.map((error, index) => (
								<li key={index}>{error}</li>
							))
						}
					</div>
				</M.Body>
				<M.Footer>
					<div className='centrador'>
						<button
							className='btn outline-boton'
							onClick={() => setModalServicioNoCompleto(false)}
						>
							<b>Cerrar</b>
						</button>
					</div>
				</M.Footer>
			</M>

			<M
				centered={true}
				show={ModalErrorConsulta}
			>
				<M.Header>
					<div className='titulo-modal'>Ups... !</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-servicio descripcion-modal'>
						Parece que hubo un error al enviar los datos, vuelvalo a intentar mas tarde.
					</div>
				</M.Body>
				<M.Footer>
					<div className='centrador'>
						<button
							className='btn outline-boton'
							onClick={() => setModalErrorConsulta(false)}
						>
							<b>Cerrar</b>
						</button>
					</div>
				</M.Footer>
			</M>

			<M
				centered={true}
				show={ModalServicioOk}
			>
				<M.Header>
					<div className='titulo-modal'>¡Enorabuena!</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-servicio descripcion-modal'>
						Su servicio ha sido registrado correctamente
					</div>
				</M.Body>
				<M.Footer>
					<div className='centrador'>
						<button
							className='btn login-boton'
							onClick={() => setModalServicioOk(false)}
						>
							<b>Cerrar</b>
						</button>
					</div>
				</M.Footer>
			</M>

			<M
				centered={true}
				show={ModalErrorCargarCategorias}
			>
				<M.Header>
					<div className='titulo-modal'>Ups... !</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-servicio descripcion-modal'>
						Parece que hubo un error al cargar la lista de categorias.
					</div>
				</M.Body>
				<M.Footer>
					<div className='centrador'>
						<button
							className='btn outline-boton'
							onClick={() => setModalErrorCargarCategorias(false)}
						>
							<b>Cerrar</b>
						</button>
					</div>
				</M.Footer>
			</M>

			<M
				centered={true}
				show={ModalErrorCargarServicios}
			>
				<M.Header>
					<div className='titulo-modal'>Ups... !</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-servicio descripcion-modal'>
						Parece que hubo un error al cargar la lista de servicios.
					</div>
				</M.Body>
				<M.Footer>
					<div className='centrador'>
						<button
							className='btn outline-boton'
							onClick={() => setModalErrorCargarServicios(false)}
						>
							<b>Cerrar</b>
						</button>
					</div>
				</M.Footer>
			</M>
		</>
	);
};
